import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoindorecab() {



    const cardData = {

keyword: "Pune to Indore Cab",

headingDescription:
    "Rising Cab Service offers safe, reliable, and comfortable Pune to Indore Cab services for families, business travelers, tourists, and long-distance passengers. We provide well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury vehicles with experienced chauffeurs for a smooth interstate journey. Our service includes one-way and round-trip options, doorstep pickup from Pune, 24/7 booking support, and transparent pricing. Whether you are traveling for business, pilgrimage, education, or leisure, Rising Cab Service ensures a hassle-free and enjoyable journey from Pune to Indore.",

topPlaces: [
    {
        title: "Rajwada Palace",
        description:
            "Rajwada Palace is the historic heart of Indore and one of the city's most iconic landmarks. Built by the Holkar dynasty, the seven-story palace showcases a blend of Maratha, Mughal, and French architectural styles."
    },
    {
        title: "Lal Bagh Palace",
        description:
            "Lal Bagh Palace is a magnificent royal residence of the Holkar rulers, famous for its grand interiors, European-style architecture, and beautifully maintained gardens."
    },
    {
        title: "Khajrana Ganesh Temple",
        description:
            "Khajrana Ganesh Temple is one of the most revered temples in Indore, attracting thousands of devotees who visit to seek the blessings of Lord Ganesha."
    },
    {
        title: "Sarafa Bazaar",
        description:
            "Sarafa Bazaar is Indore's famous night food market where visitors can enjoy a wide variety of local delicacies, sweets, and traditional street food."
    },
    {
        title: "56 Dukan",
        description:
            "56 Dukan is a popular food street featuring numerous eateries serving Indore's famous snacks and dishes, making it a favorite destination for food lovers."
    },
    {
        title: "Kanch Mandir",
        description:
            "Kanch Mandir is a unique Jain temple beautifully decorated with intricate glasswork, mirrors, and artistic craftsmanship throughout the structure."
    },
    {
        title: "Annapurna Temple",
        description:
            "Annapurna Temple is a grand Hindu temple dedicated to Goddess Annapurna and is admired for its impressive entrance and intricate sculptures."
    },
    {
        title: "Ralamandal Wildlife Sanctuary",
        description:
            "Ralamandal Wildlife Sanctuary is a peaceful natural reserve near Indore known for its scenic beauty, trekking trails, and diverse wildlife."
    },
    {
        title: "Patalpani Waterfall",
        description:
            "Patalpani Waterfall is a scenic attraction near Indore, especially popular during the monsoon season for its lush greenery and cascading waters."
    },
    {
        title: "Omkareshwar Jyotirlinga",
        description:
            "Omkareshwar Jyotirlinga, located near Indore, is one of the twelve sacred Jyotirlingas of Lord Shiva and an important pilgrimage destination for devotees from across India."
    }
],



services: [
{
    name: "Pune to Indore Cab",
    description: "Rising Cab Service offers Pune to Indore Cab with comfortable, safe, and reliable long-distance travel for families, business travelers, tourists, and corporate clients. Our service includes one-way and round-trip options with experienced drivers, clean AC vehicles, transparent pricing, and 24x7 customer support. Customers can choose from Sedan, SUV, Ertiga, Innova, and Innova Crysta vehicles for a smooth highway journey between Pune and Indore. We also provide flexible pickup and drop locations, doorstep service, airport transfers, and customized travel plans for a convenient intercity travel experience."
},
{
    name: "Pune to Indore Taxi",
    description: "Book Pune to Indore Taxi with Rising Cab Service for safe and affordable outstation travel. Our professional drivers, well-maintained fleet, and easy booking process ensure a comfortable ride for business trips, family vacations, and personal travel with flexible scheduling and reliable service."
},
{
    name: "Cab from Pune to Indore",
    description: "Cab from Pune to Indore by Rising Cab Service provides hassle-free intercity transportation with clean vehicles, experienced chauffeurs, and transparent fares. Enjoy convenient doorstep pickup, comfortable seating, and safe long-distance travel for every journey."
},
{
    name: "Taxi from Pune to Indore",
    description: "Taxi from Pune to Indore offers dependable travel solutions with AC cabs, verified drivers, and flexible one-way or round-trip bookings. Rising Cab Service focuses on passenger comfort, safety, and punctuality throughout the journey."
},
{
    name: "Pune to Indore Cab Service",
    description: "Our Pune to Indore Cab Service is ideal for business travel, family vacations, and tourism. Rising Cab Service provides affordable rates, professional drivers, comfortable vehicles, and 24x7 booking support for a pleasant travel experience."
},
{
    name: "Pune to Indore Taxi Fare",
    description: "Get competitive Pune to Indore Taxi Fare with Rising Cab Service offering transparent pricing and quality service. Our fare structure includes comfortable AC vehicles, experienced drivers, and flexible travel options for every customer."
},
{
    name: "Pune to Indore One Way Cab",
    description: "Pune to Indore One Way Cab is perfect for passengers requiring a single-drop journey without return charges. Rising Cab Service provides affordable one-way travel with comfortable vehicles and professional drivers."
},
{
    name: "Pune to Indore Round Trip Taxi",
    description: "Book Pune to Indore Round Trip Taxi for flexible travel plans including waiting and return journeys. Rising Cab Service ensures safe, comfortable, and economical transportation for business and leisure travelers."
},
{
    name: "Pune to Indore Cab Booking",
    description: "Rising Cab Service offers simple and quick Pune to Indore Cab Booking with instant confirmation, multiple vehicle choices, and 24x7 support for stress-free intercity travel."
},
{
    name: "Cheap Pune to Indore Cab",
    description: "Cheap Pune to Indore Cab provides economical travel without compromising comfort or safety. Rising Cab Service offers affordable fares, clean vehicles, and reliable drivers for budget-friendly journeys."
},
{
    name: "Best Pune to Indore Taxi",
    description: "Best Pune to Indore Taxi by Rising Cab Service combines affordability, comfort, and reliability with premium vehicles, professional chauffeurs, and dependable customer service."
},
{
    name: "Sedan Pune to Indore Cab",
    description: "Sedan Pune to Indore Cab offers comfortable and economical long-distance travel for individuals and small families. Rising Cab Service provides clean AC sedans with experienced drivers."
},
{
    name: "SUV Pune to Indore Taxi",
    description: "SUV Pune to Indore Taxi is ideal for larger families and groups requiring spacious seating and luggage capacity. Rising Cab Service ensures a safe and comfortable highway travel experience."
},
{
    name: "Innova Pune to Indore Cab",
    description: "Innova Pune to Indore Cab provides premium group travel with spacious interiors, comfortable seating, and professional drivers for long-distance journeys."
},
{
    name: "Intercity Cab Pune Indore",
    description: "Intercity Cab Pune Indore offers reliable long-distance transportation with flexible schedules, comfortable vehicles, and experienced drivers for business and leisure travel."
},
{
    name: "Pune to Bhopal Cab Booking",
    description: "Rising Cab Service provides Pune to Bhopal Cab Booking with one-way and round-trip options, comfortable AC vehicles, transparent pricing, and professional chauffeurs."
},
{
    name: "Pune to Bhopal Cab Service",
    description: "Pune to Bhopal Cab Service ensures safe and convenient travel with clean vehicles, trained drivers, and flexible booking options for personal and business trips."
},
{
    name: "Pune to Bhopal Taxi Service",
    description: "Book Pune to Bhopal Taxi Service for reliable intercity transportation with affordable fares, comfortable vehicles, and 24x7 travel assistance."
},
{
    name: "Pune to Bhopal Cab",
    description: "Pune to Bhopal Cab offers smooth highway travel with verified drivers, AC vehicles, and flexible travel plans suitable for families and corporate travelers."
},
{
    name: "Best Pune to Bhopal Cab",
    description: "Best Pune to Bhopal Cab by Rising Cab Service delivers premium travel quality, punctual pickups, and dependable transportation for long-distance journeys."
},
{
    name: "One Way Pune to Bhopal Cab",
    description: "One Way Pune to Bhopal Cab provides affordable single-trip travel with comfortable vehicles and transparent pricing for convenient intercity transportation."
},
{
    name: "Round Trip Pune to Bhopal Taxi",
    description: "Round Trip Pune to Bhopal Taxi includes return journey convenience with flexible waiting options and professional drivers for stress-free travel."
},
{
    name: "Cheap Pune to Bhopal Cab",
    description: "Cheap Pune to Bhopal Cab offers budget-friendly travel solutions while maintaining safety, comfort, and reliable customer service."
},
{
    name: "Pune to Gwalior Cab",
    description: "Pune to Gwalior Cab by Rising Cab Service provides long-distance travel with clean AC vehicles, experienced drivers, and flexible one-way and round-trip bookings."
},
{
    name: "Pune to Gwalior Cab Service",
    description: "Pune to Gwalior Cab Service ensures safe and comfortable intercity transportation with professional chauffeurs and transparent pricing."
},
{
    name: "Pune to Gwalior Taxi Service",
    description: "Book Pune to Gwalior Taxi Service for reliable travel with well-maintained vehicles, affordable fares, and excellent customer support."
},
{
    name: "Pune to Gwalior Cab Booking",
    description: "Pune to Gwalior Cab Booking provides instant reservations, multiple vehicle options, and dependable service for family and business travel."
},
{
    name: "Best Pune to Gwalior Cab",
    description: "Best Pune to Gwalior Cab combines premium comfort, safe driving, and affordable pricing for a smooth and enjoyable travel experience."
},
{
    name: "One Way Pune to Gwalior Cab",
    description: "One Way Pune to Gwalior Cab offers cost-effective long-distance transportation with doorstep pickup and comfortable travel arrangements."
}
],

tableData: [
["Pune to Indore Cab","Pune to Indore Taxi"],
["Cab from Pune to Indore","Taxi from Pune to Indore"],
["Pune to Indore Cab Service","Pune to Indore Taxi Fare"],
["Pune to Indore One Way Cab","Pune to Indore Round Trip Taxi"],
["Pune to Indore Cab Booking","Cheap Pune to Indore Cab"],
["Best Pune to Indore Taxi","Sedan Pune to Indore Cab"],
["SUV Pune to Indore Taxi","Innova Pune to Indore Cab"],
["Intercity Cab Pune Indore","Pune to Bhopal Cab Booking"],
["Pune to Bhopal Cab Service","Pune to Bhopal Taxi Service"],
["Pune to Bhopal Cab","Best Pune to Bhopal Cab"],
["One Way Pune to Bhopal Cab","Round Trip Pune to Bhopal Taxi"],
["Cheap Pune to Bhopal Cab","Pune to Gwalior Cab"],
["Pune to Gwalior Cab Service","Pune to Gwalior Taxi Service"],
["Pune to Gwalior Cab Booking","Best Pune to Gwalior Cab"],
["One Way Pune to Gwalior Cab","Intercity Cab Pune Indore"]
],




whychoose: [
    {
        WhyChooseheading: "Comfortable Pune to Indore Cab Service",
        WhyChoosedescription: "Rising Cab Service offers reliable Pune to Indore cab transportation for families, business travelers, tourists, students, and long-distance travelers seeking a convenient journey."
    },
    {
        WhyChooseheading: "Ideal for Business and Personal Travel",
        WhyChoosedescription: "Whether visiting Indore for corporate meetings, educational purposes, family functions, medical visits, or vacations, we provide dependable travel solutions."
    },
    {
        WhyChooseheading: "Travel with Premium and Spacious Vehicles",
        WhyChoosedescription: "Customers can choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and luxury vehicles based on passenger count and travel preferences."
    },
    {
        WhyChooseheading: "Flexible One-Way and Round Trip Options",
        WhyChoosedescription: "We offer one-way cab bookings, return journeys, multi-day packages, and customized travel plans to suit every requirement."
    },
    {
        WhyChooseheading: "Popular Route for Maharashtra to Madhya Pradesh Travel",
        WhyChoosedescription: "Our Pune to Indore cab service is frequently used by professionals, families, pilgrims, and tourists traveling between the two major cities."
    },
    {
        WhyChooseheading: "Pickup Available from All Pune Locations",
        WhyChoosedescription: "Doorstep pickup services are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, Pune Airport, and nearby areas."
    },
    {
        WhyChooseheading: "Experienced Drivers for Interstate Routes",
        WhyChoosedescription: "Our trained drivers are familiar with Maharashtra and Madhya Pradesh highways, ensuring a safe and comfortable travel experience."
    },
    {
        WhyChooseheading: "Customized Itineraries and Travel Stops",
        WhyChoosedescription: "Travelers can include sightseeing destinations, religious places, business locations, meal breaks, and overnight halts according to their preferences."
    }
]
};

const faqData = [
    {
        question: "Why do travelers frequently visit Indore from Pune?",
        answer: "Indore is known for its business opportunities, educational institutions, food culture, tourist attractions, and excellent connectivity across Central India."
    },
    {
        question: "Can I book a one-way cab from Pune to Indore?",
        answer: "Yes, one-way taxi services are available along with round-trip and customized travel packages."
    },
    {
        question: "Which vehicle is recommended for Pune to Indore travel?",
        answer: "Ertiga, Innova Crysta, SUVs, and Tempo Travellers are commonly preferred for their comfort and luggage capacity."
    },
    {
        question: "Can business travelers use Pune to Indore cab services?",
        answer: "Yes, many professionals book our service for corporate meetings, conferences, industrial visits, and official travel."
    },
    {
        question: "Are family trips to Indore supported by your cab service?",
        answer: "Yes, families regularly use our service for vacations, social functions, educational visits, and personal travel."
    },
    {
        question: "Can travelers visit Ujjain during the journey?",
        answer: "Yes, customized travel plans can include Ujjain Mahakal Temple and other nearby destinations in Madhya Pradesh."
    },
    {
        question: "Do you provide Tempo Travellers for larger groups?",
        answer: "Yes, Tempo Travellers and group vehicles are available for family tours, pilgrimage groups, and corporate teams."
    },
    {
        question: "Can passengers start the trip from Pune Airport or Railway Station?",
        answer: "Yes, pickups are available from Pune Airport, Railway Station, hotels, offices, and residential locations."
    },
    {
        question: "Is advance booking recommended for Pune to Indore travel?",
        answer: "Yes, advance reservations help secure preferred vehicle options and ensure smooth travel planning."
    },
    {
        question: "How can I reserve a Pune to Indore Cab?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, or online inquiries with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Shrikant Joshi",
        feedback:
            "Our journey from Pune to Indore was extremely comfortable and well-organized. The vehicle was in excellent condition, and the driver handled the long route professionally.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Neha Agrawal",
        feedback:
            "We combined our Indore visit with a trip to Ujjain, and the entire travel experience was seamless. The flexibility and comfort provided by Rising Cab Service were truly impressive.",
        rating: 5
    }
];


    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];












const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Indore Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-indore-cab.jpg",
"description": "Book Pune to Indore Cab Service with Rising Cab Service for safe, comfortable, and long-distance intercity travel. Enjoy reliable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars at affordable prices.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-indore-cab"
}
};







    return (
        <div>

<Helmet>
  <title>Pune to Indore Cab Service | Long Distance Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Indore Cab Service for safe and comfortable long-distance travel. Get affordable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars."
/>

<meta
 name="keywords"
 content="pune to indore cab, pune to indore taxi, cab from pune to indore, taxi from pune to indore, pune to indore cab service, pune to indore taxi fare, pune to indore one way cab, pune to indore round trip taxi, pune to indore cab booking, cheap pune to indore cab, best pune to indore taxi, sedan pune to indore cab, suv pune to indore taxi, innova pune to indore cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>

            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/49.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoindorecab;